import { Box, Link, Typography } from "@mui/material"
import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { customPalette } from "../../../../../../../theme"
import { ValidateButton } from "../../../../../../components/buttons/ValidateButton/ValidateButton"
import { IconInfoCircle } from "../../../../../../components/custom-icons/icon-info-circle"
import { pagesUrl } from "../../../../../../core/appConstants"
import { ProjectContext } from "../../../../../../core/context/project/ProjectContext"
import { resolveUrl } from "../../../../../../core/services/http-service"

export function RseeDocumentListEmpty(): React.JSX.Element {
  const navigate = useNavigate()

  const { project } = useContext(ProjectContext)

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      p={5}
      gap={2}
      width="80%"
      mx="auto">
      <Typography fontSize="24px" fontWeight={600} lineHeight="36px" color={customPalette.darkBlue3} textAlign="center">
        Analysez vos résultats bureau d'étude comme un pro en quelques clics
      </Typography>
      <Typography variant="body1" py={1} textAlign="center">
        Déposez votre fichier RSEE, et en moins de 5 minutes, visualisez l'intégralité de vos résultats carbone et thermiques
        dans un dashboard clair, interactif et prêt à être présenté.
      </Typography>
      <ValidateButton
        label="Ajouter un RSEE"
        onClick={() => navigate(resolveUrl(pagesUrl.BEEM_PILOT_UPLOAD_PAGE, [project?.id, "new"]))}
      />

      <Box display="flex" alignItems="center" gap={1}>
        <IconInfoCircle sx={{ color: customPalette.black }} />
        <Typography variant="body1" py={1} textAlign="center">
          C'est quoi un RSEE ? On vous explique 👉
        </Typography>
        <Link href="https://timetobeem.com/rsee-cestquoi/" underline="hover" target="_blank" rel="noopener noreferrer">
          timetobeem.com/rsee-cestquoi
        </Link>
      </Box>
    </Box>
  )
}
